import React from "react";
import { Button as ButtonComponent, CircularProgress } from "@mui/material";

const Button = ({
  style,
  onClick,
  className,
  label = "Save",
  color = "secondary",
  variant = "contained",
  disabled = false,
  fullWidth = false,
  isLoading = false,
  ...restProps
}) => {
  return (
    <ButtonComponent
      variant={variant}
      color={color}
      onClick={onClick}
      disabled={disabled || isLoading}
      style={style}
      className={className}
      fullWidth={fullWidth || false}
      {...restProps}
    >
      {label}
      {isLoading && <CircularProgress size="14px" className="ml-2" />}
    </ButtonComponent>
  );
};

export default Button;
